module.exports = __webpack_public_path__ + "img/cinescatti_lab80_logo.c0695b9c.png";